import { useEffect, useState } from "react";
import API from "../services/api";
import "./addschool.css";

export default function AddSchool() {
  const [plans, setPlans] = useState([]);
  const [message, setMessage] = useState("");
  const [monthlyCost, setMonthlyCost] = useState(0);

  const [form, setForm] = useState({
    name: "",
    address: "",
    contact_email: "",
    contact_phone: "",
    subdomain: "",
    custom_domain: "",
    plan_id: "",
    admin_username: "",
    admin_email: "",
    admin_password: "",
    max_students_allowed: "",
    academic_year: "2025-2026",
    currency: "INR",
    timezone: "Asia/Kolkata",
    theme_color: "#4c6ef5",
    payment_mode: "direct",
    razorpay_key_id: "",
    razorpay_key_secret: "",
    plan_expiry: "",
    is_active: true,
    is_verified_by_superadmin: true,
  });

  useEffect(() => {
    loadPlans();
  }, []);

  useEffect(() => {
    calculateMonthlyCost();
  }, [form.plan_id, form.max_students_allowed]);

  const loadPlans = async () => {
    const res = await API.get("/plans/");
    setPlans(res.data.plans);
  };

  const calculateMonthlyCost = () => {
    const selectedPlan = plans.find((p) => Number(p.id) === Number(form.plan_id));
    if (!selectedPlan) return setMonthlyCost(0);

    const students = Number(form.max_students_allowed || 0);
    setMonthlyCost(students * Number(selectedPlan.price_per_student));
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await API.post("/schools/create/", form);
      setMessage("School created successfully!");
    } catch (err) {
      setMessage("Failed to create school");
    }
  };

  return (
    <div className="addschool-container">
      <div className="addschool-header">
        <span className="page-kicker">New Tenant</span>
        <h2>Add New School</h2>
        <p>Create the school account, admin login, subscription plan, and payment setup.</p>
      </div>

      {message && <div className="alert-box">{message}</div>}

      <div className="form-card">

        {/* SCHOOL NAME */}
        <div className="form-group">
          <label>School Name</label>
          <input name="name" className="input" value={form.name} onChange={handleChange} />
        </div>

        {/* ADDRESS */}
        <div className="form-group">
          <label>Address</label>
          <input name="address" className="input" value={form.address} onChange={handleChange} />
        </div>

        {/* EMAIL */}
        <div className="form-group">
          <label>Email</label>
          <input name="contact_email" className="input" value={form.contact_email} onChange={handleChange} />
        </div>

        {/* PHONE */}
        <div className="form-group">
          <label>Phone</label>
          <input name="contact_phone" className="input" value={form.contact_phone} onChange={handleChange} />
        </div>

        {/* SUBDOMAIN */}
        <div className="form-group">
          <label>Subdomain</label>
          <input name="subdomain" className="input" value={form.subdomain} onChange={handleChange} />
          <div className="domain-hint">
            URL: <strong>{form.subdomain || "school"}.navith.cloud</strong>
          </div>
        </div>

        {/* CUSTOM DOMAIN */}
        <div className="form-group">
          <label>Custom Domain (Optional)</label>
          <input name="custom_domain" className="input" value={form.custom_domain} onChange={handleChange} />
        </div>

        {/* PLAN SELECT */}
        <div className="form-group">
          <label>Select Plan</label>
          <select name="plan_id" className="input" value={form.plan_id} onChange={handleChange}>
            <option value="">Select Plan</option>
            {plans.map((p) => (
              <option key={p.id} value={p.id}>
                {p.name.toUpperCase()} — ₹{p.price_per_student}/student
              </option>
            ))}
          </select>
        </div>

        {/* ADMIN USERNAME */}
        <div className="form-group">
          <label>Admin Username</label>
          <input name="admin_username" className="input" value={form.admin_username} onChange={handleChange} />
        </div>

        {/* ADMIN EMAIL */}
        <div className="form-group">
          <label>Admin Email</label>
          <input name="admin_email" className="input" value={form.admin_email} onChange={handleChange} />
        </div>

        {/* ADMIN PASSWORD */}
        <div className="form-group">
          <label>Admin Password</label>
          <input name="admin_password" className="input" value={form.admin_password} onChange={handleChange} />
        </div>

        {/* MAX STUDENTS */}
        <div className="form-group">
          <label>Max Students Allowed</label>
          <input name="max_students_allowed" className="input" value={form.max_students_allowed} onChange={handleChange} />
        </div>

        {/* MONTHLY DUE AUTO */}
        <div className="form-group">
          <label>Monthly Due Amount (Auto)</label>
          <input className="input" value={`₹${monthlyCost}`} disabled />
        </div>

        {/* ACADEMIC YEAR */}
        <div className="form-group">
          <label>Academic Year</label>
          <input name="academic_year" className="input" value={form.academic_year} onChange={handleChange} />
        </div>

        {/* PAYMENT MODE */}
        <div className="form-group">
          <label>Payment Mode</label>
          <select name="payment_mode" className="input" value={form.payment_mode} onChange={handleChange}>
            <option value="direct">Direct (School API Keys)</option>
            <option value="partner">Partner Mode</option>
          </select>
        </div>

        {/* RAZORPAY KEY */}
        <div className="form-group">
          <label>Razorpay Key ID</label>
          <input name="razorpay_key_id" className="input" value={form.razorpay_key_id} onChange={handleChange} />
        </div>

        {/* RAZORPAY SECRET */}
        <div className="form-group">
          <label>Razorpay Key Secret</label>
          <input name="razorpay_key_secret" className="input" value={form.razorpay_key_secret} onChange={handleChange} />
        </div>

        {/* PLAN EXPIRY */}
        <div className="form-group">
          <label>Plan Expiry Date</label>
          <input type="date" name="plan_expiry" className="input" value={form.plan_expiry} onChange={handleChange} />
        </div>

        <button className="btn-primary" onClick={handleSubmit}>
          Create School
        </button>
      </div>
    </div>
  );
}
